// Builds a minimal Redux state for testing product selectors.
// Only the fields referenced by the selectors under test need to be populated.

export const buildProductState = (productOverrides: Record<string, any> = {}) => ({
  product: {
    productId: "test-product-id",
    authDescriptor: {},
    formsExpanded: false,
    _view: {
      value: {
        form: {
          seasonProductId: { value: null },
          bidId: { value: null },
          contractPeriodId: { value: null },
          detailsConfirmationId: { value: null },
          applicableProducts: [],
        },
        product: {
          netCurrencyCode: "USD",
          rackCurrencyCode: "USD",
          bids: [],
          primaryDocument: { fields: [] },
          fieldSettings: { fields: {} },
          dailySummary: { expectedGuests: 0 },
          features: { general: { product: { editable: true } } },
          canEdit: true,
          ...productOverrides,
        },
      },
    },
  },
})

// Builds a minimal Redux state for testing cost_analysis selectors.
// Products are nested under biddingRegion → ports → products.

export const buildCostAnalysisState = (products: any[] = []) => ({
  costAnalysis: {
    selectedBiddingRegionId: "region-1",
    selectedProductId: products[0]?.id ?? null,
    expandedPortId: null,
    expandedCruiseBrandId: null,
    selectedCruiseBrandId: null,
    selectedOperatorId: null,
    selectedPortId: null,
    selectedAwardSetId: null,
    selectedView: "dashboard",
    showBaseline: false,
    groupByBrand: false,
    _season: {
      value: {
        biddingRegions: [
          {
            id: "region-1",
            prospectiveAwardSets: [],
            ports: [
              {
                id: "port-1",
                products: products,
              },
            ],
          },
        ],
        cruiseBrands: [],
      },
    },
  },
})
